import { render, staticRenderFns } from "./IdentifySuccess.vue?vue&type=template&id=474f6bd6&scoped=true"
import script from "./IdentifySuccess.vue?vue&type=script&lang=js"
export * from "./IdentifySuccess.vue?vue&type=script&lang=js"
import style0 from "./IdentifySuccess.vue?vue&type=style&index=0&id=474f6bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f6bd6",
  null
  
)

export default component.exports